<template>
  <div>
    <!-- No Subscribers -->
    <div
      v-if="!subscriberCount"
      class="max-w-sm mx-auto text-center p-4 bg-warning-light text-warning-dark rounded-lg border-warning border mt-4 shadow"
    >
      You can't send this campaign yet as there aren't any subscribers in your
      Shopify email list.
      <a
        href="http://help.promo.ai/article/why-are-my-subscriber-numbers-lower-than-my-shopify-customer-numbers/?v=1559020692251"
        target="_blank"
        class="text-warning-dark font-bold block mt-2"
      >
        Find out why?
      </a>
    </div>

    <!-- Campaign Failed due to Scheduling Limit reached -->
    <div v-if="sendCampaignFailed" class="send-campaign-failed">
      <p class="mb-2">
        You can't send this campaign yet as you've reached your plans
        <a
          href="http://help.promo.ai/article/what-is-a-scheduling-limit"
          target="_blank"
          class="text-info-dark underline hover:no-underline"
        >
          scheduling limit.
        </a>
      </p>

      <p class="mb-0 font-lato md:text-lg">
        You can send again
        {{ nextSendAt | formatDateDistance }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "SendCampaignAlerts",
  props: {
    nextSendAt: {
      type: String,
      default: "",
    },
    sendCampaignFailed: {
      type: Boolean,
      default: false,
    },
    subscriberCount: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped>
.send-campaign-failed {
  @apply max-w-sm text-center p-4 bg-info-light text-info-dark rounded-lg shadow border-info border mt-4 mb-2 mx-2 text-sm;

  @screen md {
    @apply mt-6 max-w-md mx-auto text-base;
  }
}
</style>
